import { Timer } from "appworks/utils/timer";
import { gameLayers } from "game-layers";

// Space out each scene change by a frame to hopefully alleviate stuttering on mobile
export function staggerSceneChanges(layers: string[], scene: string, staggerTime: number = 16) {
    layers.forEach((layerName: string, index: number) => {
        Timer.setTimeout(() => gameLayers[layerName].setScene(scene).execute(), (1 + index) * staggerTime);
    });
}
